var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _vm.displayObject
      ? _c(
          "div",
          {
            staticClass: "solutionguide__result-product",
            class: _vm.displayObject.isFallback
              ? "solutionguide__result-product--fallback"
              : "",
          },
          [
            _vm.displayObject.src && _vm.displayObject.detail_link
              ? _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.displayObject.detail_link,
                      target: "_blank",
                    },
                  },
                  [
                    _c("img", {
                      staticClass: "solutionguide__result-product-img",
                      attrs: {
                        src: _vm.displayObject.src,
                        alt: "",
                        title: _vm.displayObject.title,
                      },
                    }),
                  ]
                )
              : _vm.displayObject.src
              ? _c("img", {
                  staticClass: "solutionguide__result-product-img",
                  attrs: {
                    src: _vm.displayObject.src,
                    alt: "",
                    title: _vm.displayObject.title,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              [
                _c(
                  _vm.displayObject.detail_link ? "a" : "p",
                  {
                    tag: "component",
                    attrs: {
                      href: _vm.displayObject.detail_link,
                      target: "_blank",
                    },
                  },
                  [
                    _vm.displayObject.title
                      ? _c("span", [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.displayObject.title)),
                          ]),
                        ])
                      : _vm._e(),
                    _vm.displayObject.title && _vm.displayObject.subtitle
                      ? _c("br")
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.displayObject.subtitle
                      ? _c("span", [_vm._v(_vm._s(_vm.displayObject.subtitle))])
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _vm.showButtonAside &&
                _vm.displayObject &&
                (!_vm.displayObject.isIndividual ||
                  _vm.displayObject.isFallback)
                  ? _c(
                      "div",
                      { staticClass: "button-wrapper spacer--top-small" },
                      [
                        _vm.displayObject.isFallback
                          ? _c(
                              "global-button",
                              {
                                attrs: { theme: "primary" },
                                on: { click: _vm.openModal },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("result.row.decor.select"))
                                ),
                              ]
                            )
                          : _c(
                              "global-button",
                              {
                                attrs: { theme: "secondary" },
                                on: { click: _vm.openModal },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("result.row.decor.change"))
                                ),
                              ]
                            ),
                        _vm._v(" "),
                        _vm.showModal
                          ? _c("decorfinder", {
                              attrs: {
                                displayMode: "modal",
                                baseProducts: [_vm.product],
                              },
                              on: {
                                close: _vm.onModalClose,
                                save: _vm.onModalSave,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.showButtonAside &&
    _vm.displayObject &&
    (!_vm.displayObject.isIndividual || _vm.displayObject.isFallback)
      ? _c(
          "div",
          { staticClass: "button-wrapper spacer--top-small" },
          [
            _vm.displayObject.isFallback
              ? _c(
                  "global-button",
                  { attrs: { theme: "primary" }, on: { click: _vm.openModal } },
                  [_vm._v(_vm._s(_vm.$t("result.row.decor.select")))]
                )
              : _c(
                  "global-button",
                  {
                    attrs: { theme: "secondary" },
                    on: { click: _vm.openModal },
                  },
                  [_vm._v(_vm._s(_vm.$t("result.row.decor.change")))]
                ),
            _vm._v(" "),
            _vm.showModal
              ? _c("decorfinder", {
                  attrs: { displayMode: "modal", baseProducts: [_vm.product] },
                  on: { close: _vm.onModalClose, save: _vm.onModalSave },
                })
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }